'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/** @constant {Object} Available media queries */
var breakpoints = {
  xs: '(min-width: 0px)',
  sm: '(min-width: 640px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 1024px)',
  xl: '(min-width: 1440px)',
  xxl: '(min-width: 1920px)'
};

exports.breakpoints = breakpoints;
